import { CardModel, PileCardModel } from "../../interface/game";
import { PileDropPolicy } from "./pile-drop-policy";

export class PileConditionalDropPolicy implements PileDropPolicy {
    constructor(
        private defaultPolicy: PileDropPolicy,
        private policyByNumber: {
            [key: number]: PileDropPolicy
        }
    ) {}

    canDrop(pile: PileCardModel[], dropCards: PileCardModel[], cards: {[key: string]: CardModel}): boolean {
        const policy = this.policyByNumber[pile.length] ?? this.defaultPolicy;
        console.log('canDrop', policy);
        return policy.canDrop(pile, dropCards, cards);
    }
}